import React from 'react'
import { Box, Group, Paper, SimpleGrid, Text } from '@mantine/core'
import { IconClock, IconDatabase, IconStar, IconUsers } from '@tabler/icons-react'
import { ThemeConfig } from '../../utils/themeConfig'

interface TrustBadgeCardProps {
  themeConfig: ThemeConfig
}

export default function TrustBadgeCard({ themeConfig }: TrustBadgeCardProps) {
  const trustData = [
    { icon: IconUsers, label: '已服务', value: '10万+', unit: '用户' },
    { icon: IconClock, label: '平均', value: '15-60秒', unit: '快速生成' },
    { icon: IconStar, label: '用户满意度', value: '99%', unit: '' },
    { icon: IconDatabase, label: '数据支持', value: '大数据分析', unit: '智能整合' },
  ]

  return (
    <Paper
      p="md"
      radius="lg"
      className="mb-6"
      style={{
        backgroundColor: themeConfig.surfaceMutedColor,
        border: `1px solid ${themeConfig.surfaceBorderColor}`,
      }}
    >
      <SimpleGrid cols={{ base: 2, lg: 2 }} spacing="md">
        {trustData.map((item, index) => (
          <Group key={index} gap="xs" wrap="nowrap">
            <Box
              style={{
                padding: '6px',
                borderRadius: '8px',
                backgroundColor: `${themeConfig.primaryColor}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <item.icon size={18} color={themeConfig.primaryColor} />
            </Box>
            <div className="flex-1 min-w-0">
              <Group gap={4} wrap="nowrap">
                <Text size="xs" c="dimmed" className="whitespace-nowrap">
                  {item.label}
                </Text>
                <Text size="sm" fw={600} style={{ color: themeConfig.accentTextColor }} className="whitespace-nowrap">
                  {item.value}
                </Text>
              </Group>
              {item.unit && (
                <Text size="xs" c="dimmed" className="truncate">
                  {item.unit}
                </Text>
              )}
            </div>
          </Group>
        ))}
      </SimpleGrid>
    </Paper>
  )
}
